export default __webpack_public_path__ + "static/media/googleAssistant.3227e84a.svg";